var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L8 8L14 2",
    stroke: "#172B4D",
    strokeWidth: 2.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/down-icon.a0db4aab.svg";
export { ForwardRef as ReactComponent };